import { cn } from "@/lib/utils";
import Image from "next/image";
import React from "react";
import { ButtonProps, buttonVariants } from "../../buttons/Button";
import Link from "next/link";

export type InspirationItemProps = {
  buttonText: string;
  imageURl: string;
  image: any;
  className?: string;
  buttonVariant: ButtonProps["variant"];
  buttonSize: ButtonProps["size"];
  href: string;
  buttonClassname?: string;
};

const InspirationItem = ({
  buttonText,
  imageURl,
  image,
  className,
  buttonSize,
  buttonVariant,
  buttonClassname,
  href,
}: InspirationItemProps) => {
  return (
    <div className={cn("group relative h-[511px] w-full max-w-[285px] overflow-hidden rounded-lg", className)}>
      {imageURl && (
        <Image
          alt={image.alt || ""}
          src={imageURl}
          width={image.dimensions.width}
          height={image.dimensions.height}
          // height={511}
          className="h-full w-full rounded-lg object-cover"
          priority
        />
      )}
      {buttonText && (
        <Link
          href={href || "#"}
          className="focus-visible:ring-pink-primary/80 absolute inset-0 z-0 focus:outline-none focus-visible:ring-[3px] focus-visible:ring-offset-1"
        >
          <span
            className={cn(
              "absolute bottom-3 left-3",
              buttonClassname,
              buttonVariants({ variant: buttonVariant, size: buttonSize })
            )}
          >
            {buttonText}
          </span>
        </Link>
      )}
    </div>
  );
};

export default InspirationItem;
